import useBrowserStorage from "./useBrowserStorage";

export default function useLocalStorage(key, defaultValue) {
  return useBrowserStorage(key, defaultValue, window.localStorage);
}
